import type { SVGProps } from 'react';

function LakeIcon({ width = 120, height = 80, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox="0 0 100 100" preserveAspectRatio="none" {...props}>
      <path
        d="M5 55
           C 5 30, 25 15, 50 18
           C 75 21, 96 32, 95 55
           C 94 78, 70 90, 48 88
           C 24 86, 5 78, 5 55 Z"
        fill="#6fb4d9"
        stroke="#2f2f2f"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M18 50 C 30 45, 40 55, 52 50 C 64 45, 74 55, 86 50"
        fill="none"
        stroke="#bfe3f5"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path
        d="M20 65 C 32 60, 42 70, 54 65 C 66 60, 76 70, 88 65"
        fill="none"
        stroke="#bfe3f5"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default LakeIcon;
